import { Clazz } from './clazz'
import { Gender } from './gender'
import { Teacher } from './teacher'

export type IJumpropeIntelligentQuery = {
  clazzId: number | null
  keyword: string | null
}

export type IJumpropeIntelligentClazz = Clazz & {
  jump_completed_student_count: number
  jump_uncompleted_student_count: number
}

export interface IJumpropeIntelligentDevice {
  no: number
  device_id: string
  device_type: string
  group_name: string
}

export interface IJumpropeIntelligentDeviceGroup {
  device_type: string
  group_name: string
  devices: IJumpropeIntelligentDevice[] // 按照 no 已排好序
}

export interface IJumpropeIntelligentStudent {
  gender: Gender
  full_name: string
  best_jump_count?: number | null
  best_score_duration_in_ms?: number | null // 定数情况下达成时间，毫秒
  student_enrollment_no: string
  jump_record_list: Array<{
    student_enrollment_no: string
    created_time: string
    // value: number
    jump_count: number
    jump_duration_in_ms: number
  }>
}

export interface IJumpropeIntelligentStudentSelectable extends IJumpropeIntelligentStudent {
  folded: boolean
  selected: boolean
}

export class JumpropeIntelligentUtil {
  public static groupDevices(devices: IJumpropeIntelligentDevice[]): IJumpropeIntelligentDeviceGroup[] {
    // 按照 group_name 分组
    if (!devices.length) return []
    const result: IJumpropeIntelligentDeviceGroup[] = []
    for (const d of devices) {
      const group = result.find((g) => g.group_name === d.group_name)
      if (!group) {
        result.push({
          group_name: d.group_name,
          device_type: d.device_type,
          devices: [d],
        })
      } else {
        if (d.device_type === JumpropeIntelligentConstants.DeviceTypeCC) {
          // 如果有一个是中控，则认为当前整个分组是中控分组
          group.device_type = JumpropeIntelligentConstants.DeviceTypeCC
          group.devices.unshift(d) // 放在第一个
        } else {
          group.devices.push(d)
        }
      }
    }
    for (const g of result) {
      g.devices.sort((a, b) => a.no - b.no) // 进行排序
    }
    return result
  }
  public static getGroupName(deviceGroups: IJumpropeIntelligentDeviceGroup[], currentGroupName: string | null): string {
    if (currentGroupName) {
      // 当前有对应分组，则保持不变
      const group = deviceGroups.find((g) => g.group_name === currentGroupName)
      if (group) return currentGroupName
    }
    // 当前没有对应分组，则取第一个
    if (deviceGroups.length) {
      return deviceGroups[0].group_name
    }
    return ''
  }
}

export enum JumpropeIntelligentStudentGroup {
  All = 'all',
  Boy = 'boy',
  Girl = 'girl',
  Untest = 'untest',
}

export class JumpropeIntelligentConstants {
  public static readonly EventGroupTime = 'jump_rope_by_time' // 按时间的drill，eg 60秒
  public static readonly EventGroupCount = 'jump_rope_by_count' // 按个数
  // 设备中控
  public static readonly DeviceTypeCC = 'SS_ROPE_CC'
  // 设备跳绳
  public static readonly DeviceTypeJumpRope = 'JUMP_ROPE'

  // public static readonly TimeTargets = [30, 45, 60, 90, 120, 60 * 3, 60 * 4, 60 * 5, 60 * 10, 60 * 12, 60 * 15, 60 * 20]
  public static readonly TimeTargets = [30, 45, 60, 90, 120, 60 * 3, 60 * 4, 60 * 5, 60 * 10]
  public static readonly CountTarget = [50, 100, 150, 200, 300, 400, 500, 600, 700, 800, 1000, 2000]

  public static buildEventName(eventType: string, target: number): string {
    if (eventType === this.EventGroupTime) {
      if (target % 60 === 0) {
        return `${target / 60}分钟跳绳`
      } else {
        return `${target}秒跳绳`
      }
    } else {
      return `跳绳${target}个`
    }
  }

  public static formatShowTarget(result: number | null | undefined, event?: { event_type: string }): string | number {
    if (!result) {
      return '--'
    }
    if (event && event.event_type === this.EventGroupCount) {
      const seconds = Math.floor(result / 1000)
      const m = Math.floor(seconds / 60)
      const s = Math.floor(seconds % 60)
      // pad 0 如果只有一个数，前面补0
      const showSecs = s < 10 ? `0${s}` : s
      let leftSeconds = Math.round((result % 1000) / 100)
      if (leftSeconds >= 10) {
        leftSeconds = 0 // 前面已经round过了，这里直接是0
      }
      if (leftSeconds) {
        return `${m}:${showSecs}.${leftSeconds}`
      } else {
        return `${m}:${showSecs}.0`
      }
    } else {
      return result
    }
  }

  public static formatShowTimeTarget(target: number): string {
    // 创建quiz时使用,不会有小数点
    const min = Math.floor(target / 60)
    const sec = target % 60
    return String(min) + ':' + String(sec).padStart(2, '0')
  }
}

export interface JumpropeIntelligentInClassQuiz {
  // 课堂测验数据结构
  id: string
  title: string
  teacher: Teacher
  event: {
    event_type: string
    target: number
  }
  created_time: string | Date
}
export interface JumpropeIntelligentInClassQuizClazz {
  clazz: Clazz
  count: number
  total: number
}
